<template>
  <UContainer>
    <ExpandableList
      v-slot="{ displayItems }"
      :items="prideTabEntries"
      :limit="9"
    >
      <CommonGridCards
        :items="displayItems"
        :pending="pending"
        empty-text="Нет данных о выдающихся учениках"
      >
        <template #card="{ item }">
          <CommonCard
            :item="item"
            image-top-left="directions"
            title-right="directions"
            description-under-right="directions"
            :ui="{
              title: 'max-sm:line-clamp-1',
            }"
          />
        </template>
      </CommonGridCards>
    </ExpandableList>
  </UContainer>
</template>

<script lang="ts" setup>
import ExpandableList from '~/components/ExpandableList.vue'

defineOptions({
  name: 'SchoolDetailOurPride',
})

const { routeId } = useRouteId()

const schoolStore = useSchoolStore()
const { prideTabEntries } = storeToRefs(schoolStore)

const { pending } = await useAppAsyncData(
  `school-${routeId}-our-pride`,
  async () => {
    await schoolStore.fetchPrideTabEntries(routeId)
  },
)
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 416px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 358px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 340px;
    --card-image-height: 155px;

    :deep(.body-header) {
      display: none;
    }
  }

  &:hover {
    .image {
      transform: scale(1.15);
    }
  }

  .image-wrapper {
    overflow: hidden;
  }
}
</style>
